import { useEffect, useState } from "react";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { TAG_MISSING_NEW_REPORT } from "../interfaces/dashboard";
import { TAG_MISSING_NEW_REPORT_DATA } from "../constants/data.cnst";
import Reports from "../components/reports";

export default function TagMissingNew() {

    const tagMissingNewReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.TAG_MISSING_NEW_REPORT;

    const [tagMissingNewReportTableData, setTagMissingNewReportTableData] = useState<TAG_MISSING_NEW_REPORT[]>([]);

    useEffect(() => {
        setTagMissingNewReportTableData(TAG_MISSING_NEW_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="TAG_MISSING_NEW"
        tableColumns={tagMissingNewReportTableColumns}
        tableData={tagMissingNewReportTableData} />
    );
}